/*eslint-disable*/
import React from "react";
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

class SimpleFooter extends React.Component {
  render() {
    return (
      <>
        <footer className=" footer">
          <Container>
            <Row className=" align-items-center justify-content-md-between">
              <Col md="4">
                <div className=" copyright">
                  © {new Date().getFullYear()}{" "}
                  <a
                    href="https://energycertiificate.com"
                    target="_blank"
                  >
                    EnergyCertiificates
                  </a>

                </div>
              </Col>
              <Col md="8">
                <Nav className=" nav-footer justify-content-end">
                  <NavItem>
                    <NavLink
                      href="/politica-de-cookies"
                    >
                      Política de cookies
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                        href="/politica-de-privacidad"
                    >
                      Política de privacidad
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                        href="/terminos-y-condiciones"
                    >
                      Terminos y condiciones
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </Container>
        </footer>
      </>
    );
  }
}

export default SimpleFooter;
